import React from 'react';

interface IIf {
  isTrue: boolean;
  children: React.ReactNode;
}

const If = (props: IIf): JSX.Element => <>{props.isTrue && props.children}</>;

export default If;
